<template>
  <div class="claim-type-step-claim-item flex flex-col" :class="wrapperClasses">
    <div class="claim-type-contact-info">
      <div class="flex items-end">
        <common-text-box-small
          title="名前"
          class="w-1/2 mr-8 mb-8"
          placeholder="名前"
          :showTitle="true"
          :isDisabled="true"
        />
        <common-text-box-small
          class="w-1/2 mb-8"
          placeholder="カナ"
          :showTitle="true"
          :isDisabled="true"
        />
      </div>
      <common-text-box-small
        title="電話番号"
        class="w-1/2 mb-8 mr-4"
        :showTitle="true"
        :isDisabled="true"
      />
      <common-text-box-small
        title="メールアドレス"
        class="mb-8 w-full"
        :showTitle="true"
        :isDisabled="true"
      />
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import CommonTextBoxSmall from "../components/molecules/CommonTextBoxSmall.vue";
export default {
  components: {
    CommonTextBoxSmall,
  },
  mixins: [ColorMixin],
  name: "O.ClaimTypeTextSmall",
  props: {
    wrapperClasses: {
      type: Array, // Array<String>
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},

  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.claim-type-step-claim-item {
  .claim-type-contact-info {
    font-size: 14px;
  }
}
</style>
